import React,{useState} from 'react'
import { Link } from 'react-router-dom'
import TopImage from '../../images/plans.svg'
import { Services } from '../../api/Services'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLanguage } from '../../context/LanguageContext'
import { translations } from '../../translations/translations'

const Pricing = () => {
  const { language } = useLanguage();
  const t = translations[language].pricing;

  const [loading,setLoading]=useState('')
  const [firstName,setFirstName]=useState('')
  const [lastName,setLastName]=useState('')
  const [email,setEmail]=useState('')
  const [phone,setPhone]=useState('')
  const [bestwaytocontact,setBestwaytocontact]=useState('')
  const [ownerormanager,setOwnerormanager]=useState('')
  const [businessPlan,setBusinessPlan]=useState('')
  const [restaurantName,setRestaurantName]=useState('')
  const [purposeOfContact,setPurposeOfContact]=useState('')
  const [restaurantAddress,setRestaurantAddress]=useState('')
  const [tableExpectation,settableExpectation]=useState('')
  const handlePlanChange = (event) => {
    setBusinessPlan(event.target.id); 
  };
  const registerFunction = async (data) => {
    let formData = new FormData()
    if(firstName){
      formData.append('first_name',firstName)
    }
    if(lastName){
      formData.append('last_name',lastName)
    }
    if(email){
      formData.append('email',email)
    }
    if(phone){
      formData.append('phone',phone)
    }
    if(bestwaytocontact){
      formData.append('best_way_to_contact',bestwaytocontact)
    }
    if(ownerormanager){
      formData.append('is_owner_or_manager',ownerormanager)
    }
    if(businessPlan){
      formData.append('fitting_business_plan',businessPlan)
    }
    if(restaurantName){
      formData.append('restaurant_name',restaurantName)
    }
    if(restaurantAddress){
      formData.append('restaurant_address',restaurantAddress)
    }
    if(purposeOfContact){
      formData.append('purpose_of_contact_us',purposeOfContact)
    }
    if(tableExpectation){
      formData.append('online_enable_table_expectation',tableExpectation)
    }
    setLoading(true)
try {
  const response =  await Services.registrationApi(formData);
  setLoading(false)
    
  
  // console.log(response);
  if(response.data.success === true){
    setFirstName('')
    setLastName('')
    setEmail('')
    setPhone('')
    setBusinessPlan('')
    setBestwaytocontact('')
    setOwnerormanager('')
    setRestaurantAddress('')
    setRestaurantName('')
    setPurposeOfContact('')
    settableExpectation('')
    
      toast.success(t.messages.success,{
          autoClose:1500,
          pauseOnHover:true,
          draggable:true,
          
        });
       
  }
  
  else{
    setLoading(false)
   
    toast.error(response?.data?.errors[0],{
      autoClose:2000,
      pauseOnHover:true,
      draggable:true,
      
    });
  }
  
} catch (error) {
  setLoading(false)

  
  console.log('rrr',error)
  toast.error(t.messages.error,{
    autoClose:2000,
    pauseOnHover:true,
    draggable:true,
    
  });
}

 

}

  return (
    <div className="why-avopla-container">
          <ToastContainer />
      {loading && <div className="parent-loader">
        <div className="_loader"></div></div>}
    <div className="main-header mb-40">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-7">
              <div className="content">
                <h2 className="title">
                {t.hero.title}
                <br />
                <span>{t.hero.subtitle}</span>
                </h2>
              
                <div className="flex-30">
                  <Link className="button" to='/registration' style={{ background: '#CA2E54' }}>{t.hero.registerButton}</Link>
                  
                </div>
              </div>
            </div>
            <div className="col-12 col-md-5">
              <div className="image-wrapper">
                <img src={TopImage} alt="Pricing plans" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="new-text">
        <h2 className="title">
          {t.shine.title}
        </h2>
        <p className="text">
          {t.shine.text}
        </p>
      </div>
      <div className="container">
      <div className="price-wrapper mb-40">
        <h2 className="title uppercase">
        {t.plans.title}
        </h2>
        <h2 className="subtitle uppercase">
        {t.plans.subtitle}
        </h2>
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="price-box">
              <div className="header">
                <p className="title text-center uppercase">
                {t.basic.title}
                </p>
                <Link to='/registration' className="button">
                {t.basic.getStarted}
                </Link>
              </div>
              <div className="content">
                 <div className="item">
                  <div className="circle">

                  </div>
                  <div>
                  {t.basic.features.f1}
                  </div>
                 </div>
                 <div className="item">
                  <div className="circle">

                  </div>
                  <div>
                  {t.basic.features.f2}
                  </div>
                 </div>
                 <div className="item">
                  <div className="circle">

                  </div>
                  <div>
                  {t.basic.features.f3}
                  </div>
                 </div>
                 <div className="item">
                  <div className="circle">

                  </div>
                  <div>
                  {t.basic.features.f4}
                  </div>
                 </div>
                 <div className="item">
                  <div className="circle">

                  </div>
                  <div>
                  {t.basic.features.f5}
                  </div>
                 </div>
                 <div className="item">
                  <div className="circle">

                  </div>
                  <div>
                  {t.basic.features.f6}
                  </div>
                 </div>
                 <div className="item">
                  <div className="circle">

                  </div>
                  <div>
                  {t.basic.features.f7}
                  </div>
                 </div>
                 <div className="item">
                  <div className="circle">

                  </div>
                  <div>
                  {t.basic.features.f8}
                  </div>
                 </div>
                 <div className="item">
                  <div className="circle">

                  </div>
                  <div>
                  {t.basic.features.f9}
                  </div>
                 </div>
                 <div className="item">
                  <div className="circle">

                  </div>
                  <div>
                  {t.basic.features.f10}
                  </div>
                 </div>
              </div>
              <div className="footer">
              {t.plans.cancelAnytime}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="price-box readonly">
              <div className="header">
                <div className="comming-soon">
                {t.premium.comingSoon}
                </div>
                <p className="title text-center uppercase">
                {t.premium.title}
                </p>
                <button className="button">
                {t.premium.contactSales}
                </button>
              </div>
              <div className="content">
                <p className="text">
                {t.premium.allBasic}
                </p>
                <div className="text-center mb-5">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 7.91669C21.15 7.91669 22.0833 8.85002 22.0833 10V17.9167H30C30.5525 17.9167 31.0824 18.1362 31.4731 18.5269C31.8638 18.9176 32.0833 19.4475 32.0833 20C32.0833 20.5526 31.8638 21.0825 31.4731 21.4732C31.0824 21.8639 30.5525 22.0834 30 22.0834H22.0833V30C22.0833 30.5526 21.8638 31.0825 21.4731 31.4732C21.0824 31.8639 20.5525 32.0834 20 32.0834C19.4474 32.0834 18.9175 31.8639 18.5268 31.4732C18.1361 31.0825 17.9166 30.5526 17.9166 30V22.0834H9.99996C9.44743 22.0834 8.91752 21.8639 8.52682 21.4732C8.13612 21.0825 7.91663 20.5526 7.91663 20C7.91663 19.4475 8.13612 18.9176 8.52682 18.5269C8.91752 18.1362 9.44743 17.9167 9.99996 17.9167H17.9166V10C17.9166 8.85002 18.85 7.91669 20 7.91669Z" fill="#025B51"/>
</svg>

                </div>
                 <div className="item">
                  <div className="circle">

                  </div>
                  <div>
                  {t.premium.features.f1}
                  </div>
                 </div>
                 <div className="item">
                  <div className="circle">

                  </div>
                  <div>
                  {t.premium.features.f2}
                  </div>
                 </div>
                 <div className="item">
                  <div className="circle">

                  </div>
                  <div>
                  {t.premium.features.f3}

                  </div>
                 </div>
                 <div className="item">
                  <div className="circle">

                  </div>
                  <div>
                  {t.premium.features.f4}
                  </div>
                 </div>
                 <div className="item">
                  <div className="circle">

                  </div>
                  <div>
                  {t.premium.features.f5}
                  </div>
                 </div>
                 <div className="item">
                  <div className="circle">

                  </div>
                  <div>
                  {t.premium.features.f6}
                  </div>
                 </div>
                 <div className="item">
                  <div className="circle">

                  </div>
                  <div>
                  {t.premium.features.f7}
                  </div>
                 </div>
                 
              </div>
              <div className="footer">
              {t.plans.cancelAnytime}
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div className="container">
        <div className="faq-wrapper mb-40">
          <h2 className="title">{t.faq.title}</h2>
          <h2 className="subtitle">{t.faq.subtitle}</h2>
          <div class="accordion accordion-flush my-4" id="faq-parent">
  <div class="accordion-item">
    <h2 class="accordion-header" >
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#one"  aria-controls="one">
      {t.faq.q1.question}
      </button>
    </h2>
    <div id="one" class="accordion-collapse "  data-bs-parent="#faq-parent">
      <div class="accordion-body">
      {t.faq.q1.answer}
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="flush-headingTwo">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#two" aria-expanded="false" aria-controls="two">
      {t.faq.q2.question}
      </button>
    </h2>
    <div id="two" class="accordion-collapse " aria-labelledby="flush-headingTwo" data-bs-parent="#faq-parent">
      <div class="accordion-body">
      {t.faq.q2.answer}
        </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" >
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#three" aria-expanded="false" aria-controls="three">
      {t.faq.q3.question}
      </button>
    </h2>
    <div id="three" class="accordion-collapse "  data-bs-parent="#faq-parent">
      <div class="accordion-body">
      {t.faq.q3.answer}
        </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" >
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#four" aria-expanded="false" aria-controls="four">
      {t.faq.q4.question}
      </button>
    </h2>
    <div id="four" class="accordion-collapse "  data-bs-parent="#faq-parent">
      <div class="accordion-body">
      {t.faq.q4.answer}
        </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" >
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#five" aria-expanded="false" aria-controls="five">
      {t.faq.q5.question}
      </button>
    </h2>
    <div id="five" class="accordion-collapse "  data-bs-parent="#faq-parent">
      <div class="accordion-body">
      {t.faq.q5.answer}
        </div>
    </div>
  </div>
 
           </div>
           <div className="d-flex justify-content-center">
            <button className="button">
            {t.faq.seeAll}
            </button>

           </div>
        </div>
      </div>
      <div className="container">
      <div className="contact-wrapper">
          <h2 className="title">
          {t.contact.title}
          </h2>
          <p className="subtitle">
          {t.contact.subtitle}
          </p>
          <p className="title-small">
          {t.contact.contactDetails}
          </p>
          <div className="row mb-4">
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.firstName} <sup>*</sup></label>
                <input type="text" value={firstName} onChange={(e)=>setFirstName(e.target.value)} placeholder={`${t.contact.firstName} *`} className="input" />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.lastName} <sup>*</sup></label>
                <input type="text" value={lastName} onChange={(e)=>setLastName(e.target.value)} placeholder={`${t.contact.lastName} *`} className="input" />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.email} <sup>*</sup></label>
                <input type="text" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder={`${t.contact.email} *`} className="input" />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.phone} <sup>*</sup></label>
                <input type="text" value={phone} onChange={(e)=>setPhone(e.target.value)} placeholder={`${t.contact.phone} *`} className="input" />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.bestWay}</label>
                <select name="" value={bestwaytocontact} onChange={(e)=>setBestwaytocontact(e.target.value)} id="" className="input">
                <option value="">{t.contact.selectPlaceholder}</option>
                  <option value="By Email">{t.contact.byEmail}</option>
                  <option value="By Phone">{t.contact.byPhone}</option>
                </select>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.ownOrManage}</label>
                <select name="" value={ownerormanager} onChange={(e)=>setOwnerormanager(e.target.value)} id="" className="input">
                <option value="">{t.contact.selectPlaceholder}</option>
                  <option value="Yes">{t.contact.yes}</option>
                  <option value="No">{t.contact.no}</option>
                </select>
              </div>
            </div>
            
          </div>
          <div className="custom-radio-wrapper">
            <span className="title">
            {t.contact.whichPlan}
            </span>
            <div className="right">
              <div className="custom-radio">
                <input type="radio" onChange={handlePlanChange}
          checked={businessPlan === 'basic'} name="plan" id="basic" />
                <label htmlFor="basic">{t.contact.basicPlan}</label>
              </div>
              <div className="custom-radio">
                <input type="radio" onChange={handlePlanChange}
          checked={businessPlan === 'premium'} name="plan" id="premium" />
                <label htmlFor="premium">{t.contact.premiumPlan}</label>
              </div>
            </div>

          </div>
          <p className="title-small">
          {t.contact.restaurantDetails}
          </p>
          <div className="row mb-4">
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.restaurantName} <sup>*</sup></label>
                <input type="text" value={restaurantName} onChange={(e)=>setRestaurantName(e.target.value)} placeholder={`${t.contact.restaurantName} *`} className="input" />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.restaurantAddress} <sup>*</sup></label>
                <input type="text" value={restaurantAddress} onChange={(e)=>setRestaurantAddress(e.target.value)} placeholder={`${t.contact.restaurantAddress} *`} className="input" />
              </div>
            </div>
            
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.purpose}</label>
                <select name="" value={purposeOfContact} onChange={(e)=>setPurposeOfContact(e.target.value)} id="" className="input">
                <option value="">{t.contact.selectPlaceholder}</option>
                  <option value="I want to learn about Avopla">{t.contact.learnAbout}</option>
                  <option value="I want to schedule a demo">{t.contact.scheduleDemo}</option>
                </select>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">{t.contact.howManyTables}</label>
                <select name="" value={tableExpectation} onChange={(e)=>settableExpectation(e.target.value)} id="" className="input">
                  <option value="">{t.contact.selectPlaceholder}</option>
                  <option value="5-10">{t.contact.tables5_10}</option>
                  <option value="11-20">{t.contact.tables11_20}</option>
                  <option value="21 +">{t.contact.tables21plus}</option>
                </select>
              </div>
            </div>
            
          </div>
          <div className="d-flex justify-content-end">
            <button className="button" onClick={registerFunction}>
              {t.contact.submit}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Pricing